import { kenngroesse } from './../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../../app/store";
import { kenngroesselisteState } from "./kenngroesseTypes";
import { getWithAuth } from '../../utils/api';
import { logError } from "../../utils/utils";
import { errorHandler } from '../../utils/errorHandling';

const initialState: kenngroesselisteState
    = {
    kenngroesseListe: Array<kenngroesse>(),
    kenngroesseWertTemp: Array<kenngroesse>(),
    kenngroesseWertVorher: Array<kenngroesse>(),
    kenngroesseWert: Array<kenngroesse>(),
    kenngroesseSelectInputValue: "",
    selectedGroups: [],
    openGroups: [],
    loadingKenngroesse: false,
    isChanged: false,
};

const kenngroesseSlice = createSlice({
    name: "kenngroesseFilter",
    initialState,
    reducers:
    {
        setKenngroesseWertTemp: (state, action: PayloadAction<Array<kenngroesse>>) => {
            state.kenngroesseWertTemp = action.payload
        },

        setKenngroesseWert: (state) => {
            state.kenngroesseWertVorher = state.kenngroesseWertTemp;
            state.kenngroesseWert = state.kenngroesseWertTemp;
        },

        resetKenngroesseWert: (state) => {
            state.kenngroesseWertTemp = state.kenngroesseWertVorher;
            state.kenngroesseWert = state.kenngroesseWertVorher;
        },

        setKenngroessen: (state, action: PayloadAction<kenngroesse[]>) => {
            state.kenngroesseListe = action.payload;
        },
        setAllKenngroesseAktuellerWert: (state) => {
            state.kenngroesseWertTemp = state.kenngroesseListe;
        },
        setKenngroesseSelectInputValue: (state, action: PayloadAction<string>) => {
            state.kenngroesseSelectInputValue = action.payload;
        },
        setSelectedGroups: (state, action: PayloadAction<string[]>) => {
            state.selectedGroups = action.payload;
        },
        setOpenGroups: (state, action: PayloadAction<string[]>) => {
            state.openGroups = action.payload;
        },
        selectFilteredKenngroessenOfGroup: (state, action: PayloadAction<{ groups: Array<string> | null, filter: string }>) => {
            const filter = action.payload.filter.toLowerCase();
            if (action.payload.groups) {
                const grouplessMessstellen = state.kenngroesseWertTemp.filter(x => !action.payload.groups?.includes(x.beschreibung))
                    .filter(x => state.kenngroesseListe.filter(m => m.beschreibung == x.beschreibung).length != state.kenngroesseWertTemp.filter(k => k.beschreibung == x.beschreibung).length);
                state.kenngroesseWertTemp = state.kenngroesseListe.filter(x => x.unterkategorie ? action.payload.groups?.includes(x.unterkategorie) : false);
                state.kenngroesseWertTemp = state.kenngroesseWertTemp.concat(grouplessMessstellen);
                state.kenngroesseWertTemp = state.kenngroesseWertTemp.filter(x => x.klasse.toLowerCase().includes(filter) || x.feldname.toLowerCase().includes(filter));
            } else {
                state.kenngroesseWertTemp = state.kenngroesseListe.filter(x => x.klasse.toLowerCase().includes(filter) || x.feldname.toLowerCase().includes(filter));
            }
        },
        setKenngroesseLoading: (state, action: PayloadAction<boolean>) => {
            state.loadingKenngroesse = action.payload;
        },
        setIsChangedKenngroesse: (state, action: PayloadAction<boolean>) => {
            state.isChanged = action.payload;
        }
    },
});

//Selectors
export const selectKenngroesseWert = (state: RootState): kenngroesse[] => state.kenngroesseFilter.kenngroesseWert;
export const selectKenngroesseWertTemp = (state: RootState): kenngroesse[] => state.kenngroesseFilter.kenngroesseWertTemp;
export const selectKennegroesse = (state: RootState): kenngroesse[] => state.kenngroesseFilter.kenngroesseListe;
export const selectKenngroesseSelectInputValue = (state: RootState): string => state.kenngroesseFilter.kenngroesseSelectInputValue;
export const selectSelectedGroups = (state: RootState): string[] => state.kenngroesseFilter.selectedGroups;
export const selectopenGroups = (state: RootState): string[] => state.kenngroesseFilter.openGroups;
export const selectKenngroesseLoading = (state: RootState): boolean => state.kenngroesseFilter.loadingKenngroesse;
export const selectIsChangedKenngroesse = (state: RootState): boolean => state.kenngroesseFilter.isChanged;

//Actions
export const {
    setKenngroesseWert,
    setKenngroesseWertTemp,
    resetKenngroesseWert,
    setKenngroesseLoading,
    setKenngroessen,
    setIsChangedKenngroesse,
    selectFilteredKenngroessenOfGroup,
    setSelectedGroups,
    setOpenGroups,
    setKenngroesseSelectInputValue
} = kenngroesseSlice.actions;


function setKenngroesseDescription(x: kenngroesse): kenngroesse {
    if (x.feldname == "f" && x.klasse == "c10m") {
        return { ...x, beschreibung: "10 Minuten " + x.beschreibung };
    }
    if (x.feldname == "f" && x.klasse == "c10s") {
        return { ...x, beschreibung: "10 Sekunden " + x.beschreibung };
    } else {
        return { ...x, beschreibung: x.beschreibung };
    }
}

export const getKenngroesse = (name: string) => (
    dispatch: AppDispatch
): void => {
    dispatch(setKenngroesseLoading(true));
    getWithAuth("KENNGROESSE", {}).then((response: kenngroesse[]) => {
        let responseTemp = Array<kenngroesse>();
        switch (name) {
            case "pqIndex":
                responseTemp = response.filter(x => x.pqIndex)
                break;
            case "anomalien":
                responseTemp = response.filter(x => x.anomalien)
                break;
            case "trends":
                responseTemp = response.filter(x => x.trends)
                break;
            case "korrelation":
                responseTemp = response.filter(x => x.korrelation)
                break;
        }
        responseTemp = responseTemp.map(x => setKenngroesseDescription(x))

        dispatch(setKenngroessen(responseTemp));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setKenngroesseLoading(false)));
}


export default kenngroesseSlice.reducer;